import React, { ButtonHTMLAttributes } from 'react';
import { Container } from './styles';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  loading?: boolean;
  disabled?: boolean;
  classType: string;
  width?: string | number;
}

const Button: React.FC<ButtonProps> = ({
 classType, title, loading, disabled, width = 'none', ...rest
}) => (
  <Container width={width} className={`main-button ${classType}`} disabled={loading || disabled} {...rest}>
    {loading ? <img className="loading" src={`img/loading.svg`} alt="loading" /> : title}
  </Container>
);

export default Button;
